export default {
    SET_ADMINS: (state, admins) => {
        state.admins = admins
    },

    SET_ACTIVE_ADMIN: (state, activeAdmin) => {
        state.activeAdmin = activeAdmin
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_ADMIN_FILTERS: (state) => {
        state.filters = {
            fromDate: null,
            toDate: null,
            email: null,
            name: null
        }
    }
}
